import { BASE_URL_API } from '@constants/base';
import { get } from '@utils/ajax';

/**
 * Shipping Request Service
 * Handles all shipping request related API calls
 */
const itemRegisterFrameService = (() => {
    // Get item register frame list
    const getItemRegisterFrameList = async params => {
        try {
            const response = await get(`${BASE_URL_API}/main/itemManagement/list_api.php`, params, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    // Upload item register frame
    const uploadItemRegisterFrame = async formData => {
        try {
            const response = await fetch(`${BASE_URL_API}/main/itemManagement/edit_image_api.php`, {
                method: 'POST',
                body: formData
                // Don't set Content-Type header, let browser set it with boundary for FormData
            });

            const result = await response.json();
            return result;
        } catch (error) {
            return error;
        }
    };

    return {
        getItemRegisterFrameList,
        uploadItemRegisterFrame
    };
})();

export default itemRegisterFrameService;
